import React from 'react'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import PropTypes from 'prop-types'
import ButtonCta from '@components/atoms/button-cta'
import Image from '@components/atoms/image'
import DateRange from '@components/atoms/date-range-new'
import {
  IconFlag,
  IconMarker,
} from '@components/atoms/icons'
import useStyles from './card-event-cta.styles'

const CardEventCta = (props) => {
  const {
    headline,
    image,
    course,
    location,
    startDate,
    endDate,
    logo,
    slug,
    heroImage,
  } = props
  const styles = useStyles()

  const url = (image && image.url) || (heroImage && heroImage.url) || (logo && logo.url)

  return (
    <Card className={styles.root}>
      {url && <Image className={styles.image} src={`${url}?h=200&w=600&fit=fill&fl=progressive&q=80`} alt={`View page for ${headline}`} />}
      <div className={styles.contentContainer}>
        <Image
          className={styles.logo}
          src={`${logo.url}?fm=jpg&h=200&w=200&fit=fill&fl=progressive&q=80`}
          alt={headline}
        />
        <Box className={styles.headlineWrapper}>
          <Typography variant="h6" className={styles.headline}>{headline}</Typography>
          <Box className={styles.dateRange}>
            <DateRange startDate={startDate} endDate={endDate} />
          </Box>
        </Box>
        <Box className={styles.locationWrapper}>
          {course && (
            <div className={styles.field}><IconFlag className={styles.icon} viewBox="6 0 24 24" />
              <Typography variant="caption" className={styles.fieldText}>{course}</Typography>
            </div>
          )}
          {location && (
            <div className={styles.field}><IconMarker className={styles.icon} viewBox="6 0 24 24" />
              <Typography variant="caption" className={styles.fieldText}>{location}</Typography>
            </div>
          )}
        </Box>
      </div>
      <ButtonCta
        variant="text"
        arrow
        href={`events/${slug}`}
        className={styles.ctaButton}
        dataAttrs={{ 'aria-label': `View page for ${headline}` }}
      >
        View Event
      </ButtonCta>
    </Card>
  )
}

CardEventCta.propTypes = {
  headline: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
  }),
  logo: PropTypes.shape({
    url: PropTypes.string,
  }),
  slug: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  location: PropTypes.string,
  course: PropTypes.string,
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
}

export default CardEventCta
